import styled, { css } from 'styled-components'

import { MEDIA } from '../../utils/constants'

// Media query
const { MOBILE_UP, MOBILE } = MEDIA

export const ModalBox = styled.div`
  position: fixed;
  float: left;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: ${props => props.visible ? 1073 : -100};
  display: flex;
  flex-direction: column;
  overflow: ${props => (props.overflow) ?? 'hidden !important'};
  width: 328px;
  max-width: 95vw;
  max-height: min(686px, 95vh);
  background-color: var(--the-white);
  transition: all 0.12s ease-in;
  opacity: ${props => props.visible ? 1 : 0};
  border-radius: 2.4rem;
  padding: 24px;

  font-family: var(--primary-font);
  color: var(--gray-5);
  text-align: center;

  @media screen and ${MOBILE_UP} {
    min-height: ${({ type }) => type === 'info' ? 'auto' : 'fit-content'};
    ${props => props.modalHeight && `height:${props.modalHeight}; min-height:unset;`}
    ${props => props.modalWidth && `width:${props.modalWidth}; min-width:unset;`}
    max-width: unset;
    padding: 24px;
    max-width: 90vw;
    overflow: ${props => props.overflowIncompletePet ?? 'auto'};
  }
`

export const ModalBody = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 5px 5px 0 0;
  overflow: ${({ type }) => type === 'warning' ? 'hidden' : 'unset'};

  @media screen and ${MOBILE_UP} {
    width: ${props => props.contentWidth ? `${props.contentWidth}px` : '100%'};
  }

`

export const ModalIcon = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 999999px;
  display: block;
  max-width: 100%;
  @media screen and ${MOBILE} {
    width: 64px;
  }
  ${props => props.fullIcon && `
    width: 100% !important;
    height: auto;
  `}
`

export const ModalTitle = styled.div`
  font-size: ${props => props.titleSize ? props.titleSize : '18px'};
  line-height: 27px;
  margin-top: 16px;
  color: var(--gray-2);
  font-weight: 600;
  margin-bottom: 8px;
`

export const ModalSubtitle = styled(ModalTitle)`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  font-family: var(--primary-font);
  color: var(--gray-5);
  margin-top: 8px;
  ${({ subtitleMargin }) => subtitleMargin && css`
    margin: ${subtitleMargin};
  `}
`

export const ModalContent = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  font-family: var(--primary-font);
  color: var(--gray-5)

  ${({ hasTitle }) => hasTitle && css`
    margin-top: 8px;
  `}

  a {
    color: ${props => props.type === 'info' ? 'var(--the-white);' : 'var(--cobasi-blue);'}
  }

  @media screen and ${MOBILE} {
    font-size: 1.4rem;
  }
`

export const ModalBackdrop = styled.span`
  display: ${props => props.visible ? 'flex' : 'none'};
  align-items:center;
  justify-content:center;
  content: '';
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1072;
`
export const ModalClose = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  line-height: 24px;
  right: 16px;
  top: 16px;
  position: absolute;
  border: none;
  background: none;
  cursor: pointer;
`

export const ModalFooter = styled.footer`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px auto;
  flex-direction: column;

  @media screen and ${MOBILE_UP} {
    width: ${props => props.contentWidth ? `${props.contentWidth}px` : '100%'};
    justify-content: center;
  }
`

export const CancelButton = styled.button`
  width: auto;
  height: 40px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: ${({ outlineCancelButton }) => outlineCancelButton ? 'var(--cobasi-blue-light-9)' : 'var(--the-white)'};
  font-size: 16px;
  font-weight: 600;
  font-family: var(--primary-font);
  cursor: pointer;
  background-color: ${({ outlineCancelButton }) => outlineCancelButton ? 'var(--the-white)' : 'var(--cobasi-blue-light-9)'};
  border: ${({ outlineCancelButton }) => outlineCancelButton ? '1px solid var(--cobasi-blue-light-9)' : 'none'};
  border-radius: 99px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin-top: ${({ onlyCancel }) => onlyCancel ? '16px' : '16px'};

  ${({ fullButton }) => fullButton && css`
    width: 100%;
    padding: 0px;
  `}

  svg path {
    fill: currentColor;
  }

  @media screen and ${MOBILE} {
    width: 100%;
    height: 40px;
  }
`

export const ConfirmButton = styled(CancelButton)`
  color: ${({ outlineConfirmButton }) => outlineConfirmButton ? 'var(--cobasi-blue-light-9)' : 'var(--the-white)'};
  background-color: ${({ outlineConfirmButton }) => outlineConfirmButton ? 'var(--the-white)' : 'var(--cobasi-blue-light-9)'};
  border: ${({ outlineConfirmButton }) => outlineConfirmButton ? '1px solid var(--cobasi-blue-light-9)' : 'none'};
  border-radius: 99px;

  @media screen and ${MOBILE} {
    width: 100%;
  }
`
